import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Api_Url } from '../../config/config'
import axios from 'axios'
import { Button, Divider, Modal, Table } from 'antd'
import toast from 'react-hot-toast'
import { ErrorToast, SuccessToast, UpdatedToast } from '../../views/ToastComponent'

function DairyShopDEtails() {
    const { id } = useParams()

    const [singleData, setSingleData] = useState([])
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = React.useState(false);

    const getSingleUser = async () => {
        try {
            const response = await axios.get(`${Api_Url}api/v1/DairyFarm/cattle/getallcattlebydairyfarmid/${id}`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }
            })
            setSingleData(response.data.data)
        } catch (error) {
            return error.message
        }
    }

    useEffect(() => {
        getSingleUser()
    }, [])

    const [breedData, setBreedData] = useState([])

    const AllBreedData = async () => {
        try {
            const response = await axios.get(`${Api_Url}api/v1/Breed?PageNumber=1&PageSize=1000`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }
            })
            setBreedData(response.data.data)
        } catch (error) {
            return error.message
        }
    }

    useEffect(() => {
        AllBreedData()
    }, [])




    const [dairyStoreData, setDairyStoreData] = useState({
        dairyFarmId: id,
        name: "",
        breedId: 0,
        purchasePrice: 0,
        lifeOfAnimal: 0,
        annualDeprication: 0,
        monthlyDeprication: 0,
        milkingCapacity: 0,
        milkingCapacityDuringVisit: 0,
        actualProduction: 0,
        sellingPrice: 0,
        dailyIncome: 0,
        lactationPeriod: 0,
        monthlyIncome: 0,
        latitude: "",
        longitude: ""

    })


    useEffect(() => {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(function (position) {

                const { latitude, longitude } = position.coords;
                setDairyStoreData({ ...dairyStoreData, latitude: latitude.toString(), longitude: longitude.toString() });
            });
        } else {
            console.log("Geolocation is not supported by this browser.");
        }
    }, [])


    const handleSubmit = async () => {
        try {
            const response = await axios.post(`${Api_Url}api/v1/DairyFarm/cattle`, dairyStoreData, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }
            })
            if (response.data.succeeded) {
                SuccessToast("Added Successfully")
                handleCancel()
                getSingleUser()
            }
        } catch (error) {
            ErrorToast("Something went wrong")
            return error.message
        }
    }


    const calculateMonthlyRevenue = () => {
        const result = dairyStoreData.milkingCapacityDuringVisit * 2 || 0;
        setDairyStoreData(prev => ({
            ...prev,
            actualProduction: result
        }))
    };

    const calculatePerMonth = () => {
        const result = dairyStoreData.purchasePrice / dairyStoreData.lifeOfAnimal || 0;
        const MonthDep = result / 12
        setDairyStoreData(prev => ({
            ...prev,
            annualDeprication: result,
            monthlyDeprication: MonthDep
        }))
    };

    const CalculateTodayAndMonthlyIncome = () => {
        const result = dairyStoreData.sellingPrice * dairyStoreData.actualProduction || 0;
        const monthlyIncome = (result * 30) * (dairyStoreData.lactationPeriod / 12) || 0;
        setDairyStoreData(prev => ({
            ...prev,
            dailyIncome: result,
            monthlyIncome: monthlyIncome
        }))
    };

    React.useEffect(() => {
        calculateMonthlyRevenue();
    }, [dairyStoreData.milkingCapacityDuringVisit]);

    React.useEffect(() => {
        calculatePerMonth();
    }, [dairyStoreData.purchasePrice, dairyStoreData.lifeOfAnimal]);

    React.useEffect(() => {
        CalculateTodayAndMonthlyIncome();
    }, [dairyStoreData.sellingPrice, dairyStoreData.actualProduction, dairyStoreData.lactationPeriod]);


    const handleClick = async (id) => {
        try {
            const response = await axios.get(`${Api_Url}api/v1/DairyFarm/cattle/${id}`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }

            })
            setDairyStoreData(response.data.data)
            setIsEditModalOpen(true)
        } catch (error) {
            return error.message
        }
    }


    //update Method

    const handleUpdate = async (id) => {
        try {
            const response = await axios.post(`${Api_Url}api/v1/DairyFarm/cattle/${id}`, dairyStoreData, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }
            })
            setIsEditModalOpen(false)
            if (response.data.succeeded) {
                UpdatedToast("Successfully updated")
                handleCancel()
                getSingleUser()
            }
        } catch (error) {
            ErrorToast("Something went wrong")
            return error
        }
    }


    const columns = [
        {
            title: "Breed Name",
            dataIndex: "breedName",
            // sorter: (a, b) => a.profitMarginName.length - b.profitMarginName.length,
        },
        {
            title: "Purchase Cost",
            dataIndex: "purchasePrice",
            // sorter: (a, b) => a.registrationNumber.length - b.registrationNumber.length,
        },
        {
            title: "Animal Life",
            dataIndex: "lifeOfAnimal",
            // sorter: (a, b) => a.purchaseCost.length - b.purchaseCost.length,
        },
        {
            title: "Annual Dep.",
            dataIndex: "annualDeprication",
            // sorter: (a, b) => a.lifeOfAuto.length - b.lifeOfAuto.length,
        },
        {
            title: "Monthly Dep.",
            dataIndex: "monthlyDeprication",
            // sorter: (a, b) => a.monthlyDepreciation.length - b.monthlyDepreciation.length,
        },
        {
            title: "Milk Capacity",
            dataIndex: "milkingCapacity",
            // sorter: (a, b) => a.monthlyDepreciation.length - b.monthlyDepreciation.length,
        },
        {
            title: "Milk Capacity During Visit",
            dataIndex: "milkingCapacityDuringVisit",
            // sorter: (a, b) => a.monthlyDepreciation.length - b.monthlyDepreciation.length,
        },
        {
            title: "Total Milk Production",
            dataIndex: "actualProduction",
            // sorter: (a, b) => a.monthlyDepreciation.length - b.monthlyDepreciation.length,
        },
        {
            title: "Milk Selling Price",
            dataIndex: "sellingPrice",
            // sorter: (a, b) => a.monthlyDepreciation.length - b.monthlyDepreciation.length,
        },
        {
            title: "Lacatation Period",
            dataIndex: "lactationPeriod",
            // sorter: (a, b) => a.monthlyDepreciation.length - b.monthlyDepreciation.length,
        },
        {
            title: "Daily Income",
            dataIndex: "dailyIncome",
            // sorter: (a, b) => a.monthlyDepreciation.length - b.monthlyDepreciation.length,
        },
        {
            title: "Monthly Income",
            dataIndex: "monthlyIncome",
            // sorter: (a, b) => a.monthlyDepreciation.length - b.monthlyDepreciation.length,
        },
        {
            title: 'Edit',
            dataIndex: 'edit',
            // sorter: (a, b) => a.monthlyIncome.length - b.monthlyIncome.length,
            render: (text, record) => (
                <div>
                    {text}
                    <Button
                        type="primary"
                        onClick={() => handleClick(record.id)}
                        style={{ marginLeft: '10px' }}
                    >
                        <i class="fa-solid fa-pen-to-square"></i>
                    </Button>
                </div>
            ),
        },
        // {
        //     title: 'Delete',
        //     dataIndex: 'delete',
        //     // sorter: (a, b) => a.monthlyIncome.length - b.monthlyIncome.length,
        //     render: (text, record) => (
        //         <div>
        //             {text}
        //             <Button
        //                 className='btn btn-danger'
        //                 type="primary"
        //                 // onClick={() => handleClick(record.id)}
        //                 style={{ marginLeft: '10px' }}
        //             >
        //                 <i class="fa-solid fa-trash"></i>
        //             </Button>
        //         </div>
        //     ),
        // },
    ];


    async function handleCancel() {
        setDairyStoreData({
            ...dairyStoreData,
            dairyFarmId: id,
            name: "",
            breedId: 0,
            purchasePrice: 0,
            lifeOfAnimal: 0,
            annualDeprication: 0,
            monthlyDeprication: 0,
            milkingCapacity: 0,
            milkingCapacityDuringVisit: 0,
            actualProduction: 0,
            sellingPrice: 0,
            dailyIncome: 0,
            lactationPeriod: 0,
            monthlyIncome: 0,
        })
        setIsModalOpen(false);
        setIsEditModalOpen(false)
    }


    return (

        <>
            <div className="page-wrapper">
                <div className="content container-fluid">
                    <div className="row">
                        <div className="col-12 d-flex align-items-center justify-content-between">
                            <h3 className="mb-0">Dairy Assesment</h3>
                            <button className="btn btn-primary submit-btn mb-2" onClick={() => setIsModalOpen(true)}>Add Income</button>
                        </div>
                    </div>

                    <div className="row mt-4">
                        <div className="col-12 mx-auto">
                            <Table
                                className="table-striped"
                                style={{ overflowX: "auto" }}
                                columns={columns}
                                dataSource={singleData}
                                rowKey={(record) => record.id}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* Add Modal */}
            <Modal
                title={<h4>Add Dairy Assesment</h4>}
                open={isModalOpen}
                onOk={() => setIsModalOpen(false)}
                onCancel={() => handleCancel()}
                footer={[
                    <div className='d-flex justify-content-between align-items-center'>
                        <button key="Cancel" className="btn btn-danger submit-btn" type="button" onClick={handleCancel}>Cancel</button>,
                        <button key="submit" className="btn btn-primary submit-btn" type="submit" onClick={handleSubmit}>Submit</button>
                    </div>
                ]}
                width={600}
                mask={false}
                maskClosable={false}
                closeIcon={<span style={{ color: 'red' }}>X</span>}
            >
                <div className="modal-body mt-5">
                    <form>
                        <Divider>Dairy Assesment</Divider>
                        <div className="row">
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Select Breeds:
                                    </label>
                                    <select
                                        className="form-control"
                                        value={dairyStoreData.breedId}
                                        onChange={(e) => setDairyStoreData({ ...dairyStoreData, breedId: e.target.value })}
                                    >
                                        <option value="">Select Cattel Breeds</option>
                                        {breedData && breedData.map((breed) => (
                                            <option key={breed.id} value={breed.id}>
                                                {breed.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Purchase Cost:
                                    </label>
                                    <input className="form-control" type="number" placeholder="Enter Purchase Cost" value={dairyStoreData.purchasePrice} onChange={(e) => setDairyStoreData({ ...dairyStoreData, purchasePrice: e.target.value })} />
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Life of animal (Year):
                                    </label>
                                    <input className="form-control" type="text" placeholder="Enter Life Of Animal" value={dairyStoreData.lifeOfAnimal} onChange={(e) => setDairyStoreData({ ...dairyStoreData, lifeOfAnimal: e.target.value })} />
                                </div>
                            </div>

                            <div className="row my-3">
                                <div className="col-sm-12 d-flex align-items-center justify-content-between">
                                    <p className="mb-0">Annual Dep: </p>
                                    <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {dairyStoreData.annualDeprication.toFixed(2)}</span>
                                </div>
                            </div>

                            <div className="row my-3">
                                <div className="col-sm-12 d-flex align-items-center justify-content-between">
                                    <p className="mb-0">Month Dep: </p>
                                    <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {dairyStoreData.monthlyDeprication.toFixed(2)}</span>
                                </div>
                            </div>

                        </div>

                        <div className="row">
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Milk Capacity Of animal(liter):
                                    </label>
                                    <input className="form-control" type="text" placeholder="Enter How much milk capacity of animal" value={dairyStoreData.milkingCapacity} onChange={(e) => setDairyStoreData({ ...dairyStoreData, milkingCapacity: e.target.value })} />
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Milk capacity during Visit(liter):
                                    </label>
                                    <input className="form-control" type="number" placeholder="Enter Milk Capacity during visit" value={dairyStoreData.milkingCapacityDuringVisit} onChange={(e) => setDairyStoreData({ ...dairyStoreData, milkingCapacityDuringVisit: e.target.value })} />
                                </div>
                            </div>
                        </div>

                        <div className="row my-3">
                            <div className="col-sm-12 d-flex align-items-center justify-content-between">
                                <p className="mb-0">Total Milk Production in a day: </p>
                                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {dairyStoreData.actualProduction.toFixed(2)}</span>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Selling Price (per liter):
                                    </label>
                                    <input className="form-control" type="text" placeholder="Selling price" value={dairyStoreData.sellingPrice} onChange={(e) => setDairyStoreData({ ...dairyStoreData, sellingPrice: e.target.value })} />
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Lacation Period (in month):
                                    </label>
                                    <input className="form-control" type="number" placeholder="Enter lacation period" value={dairyStoreData.lactationPeriod} onChange={(e) => setDairyStoreData({ ...dairyStoreData, lactationPeriod: e.target.value })} />
                                </div>
                            </div>
                        </div>



                        <div className="row my-3">
                            <div className="col-sm-12 d-flex align-items-center justify-content-between">
                                <p className="mb-0">Daily Income: </p>
                                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {dairyStoreData.dailyIncome.toFixed(2)}</span>
                            </div>
                        </div>

                        <div className="row my-3">
                            <div className="col-sm-12 d-flex align-items-center justify-content-between">
                                <p className="mb-0">Monthly Income: </p>
                                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {dairyStoreData.monthlyIncome.toFixed(2)}</span>
                            </div>
                        </div>
                    </form>
                </div>
            </Modal>

            {/* Edit Modal */}

            <Modal
                title={<h4>Edit Dairy Assesment</h4>}
                open={isEditModalOpen}
                onOk={() => setIsEditModalOpen(false)}
                onCancel={() => handleCancel()}
                footer={[
                    <div className='d-flex justify-content-between align-items-center'>
                        <button key="Cancel" className="btn btn-danger submit-btn" type="button" onClick={handleCancel}>Cancel</button>,
                        <button key="submit" className="btn btn-primary submit-btn" type="submit" onClick={() => handleUpdate(dairyStoreData.id)}>Update</button>
                    </div>
                ]}
                width={600}
                mask={false}
                maskClosable={false}
                closeIcon={<span style={{ color: 'red' }}>X</span>}
            >
                <div className="modal-body mt-5">
                    <form>
                        <Divider>Dairy Assesment</Divider>
                        <div className="row">
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Select Breeds:
                                    </label>
                                    <select
                                        className="form-control"
                                        value={dairyStoreData.breedId}
                                        onChange={(e) => setDairyStoreData({ ...dairyStoreData, breedId: e.target.value })}
                                    >
                                        <option value="">Select Breeds</option>
                                        {breedData && breedData.map((breed) => (
                                            <option key={breed.id} value={breed.id}>
                                                {breed.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Purchase Cost:
                                    </label>
                                    <input className="form-control" type="number" placeholder="Enter purchase cost" value={dairyStoreData.purchasePrice} onChange={(e) => setDairyStoreData({ ...dairyStoreData, purchasePrice: e.target.value })} />
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Life of animal (Year):
                                    </label>
                                    <input className="form-control" type="text" placeholder="Enter life of animal" value={dairyStoreData.lifeOfAnimal} onChange={(e) => setDairyStoreData({ ...dairyStoreData, lifeOfAnimal: e.target.value })} />
                                </div>
                            </div>

                            <div className="row my-3">
                                <div className="col-sm-12 d-flex align-items-center justify-content-between">
                                    <p className="mb-0">Annual Dep: </p>
                                    <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {dairyStoreData.annualDeprication.toFixed(2)}</span>
                                </div>
                            </div>

                            <div className="row my-3">
                                <div className="col-sm-12 d-flex align-items-center justify-content-between">
                                    <p className="mb-0">Month Dep: </p>
                                    <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {dairyStoreData.monthlyDeprication.toFixed(2)}</span>
                                </div>
                            </div>

                        </div>

                        <div className="row">
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Milk Capacity Of animal(liter):
                                    </label>
                                    <input className="form-control" type="text" placeholder="Enter milk capacity of animal" value={dairyStoreData.milkingCapacity} onChange={(e) => setDairyStoreData({ ...dairyStoreData, milkingCapacity: e.target.value })} />
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Milk capacity during Visit(liter):
                                    </label>
                                    <input className="form-control" type="number" placeholder="Enter milk capacity during visit" value={dairyStoreData.milkingCapacityDuringVisit} onChange={(e) => setDairyStoreData({ ...dairyStoreData, milkingCapacityDuringVisit: e.target.value })} />
                                </div>
                            </div>
                        </div>

                        <div className="row my-3">
                            <div className="col-sm-12 d-flex align-items-center justify-content-between">
                                <p className="mb-0">Total Milk Production in a day: </p>
                                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {dairyStoreData.actualProduction.toFixed(2)}</span>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Selling Price (per liter):
                                    </label>
                                    <input className="form-control" type="text" placeholder="Selling price" value={dairyStoreData.sellingPrice} onChange={(e) => setDairyStoreData({ ...dairyStoreData, sellingPrice: e.target.value })} />
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Lacation Period (in month):
                                    </label>
                                    <input className="form-control" type="number" placeholder="Enter lacation period" value={dairyStoreData.lactationPeriod} onChange={(e) => setDairyStoreData({ ...dairyStoreData, lactationPeriod: e.target.value })} />
                                </div>
                            </div>
                        </div>



                        <div className="row my-3">
                            <div className="col-sm-12 d-flex align-items-center justify-content-between">
                                <p className="mb-0">Daily Income: </p>
                                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {dairyStoreData.dailyIncome.toFixed(2)}</span>
                            </div>
                        </div>

                        <div className="row my-3">
                            <div className="col-sm-12 d-flex align-items-center justify-content-between">
                                <p className="mb-0">Monthly Income: </p>
                                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {dairyStoreData.monthlyIncome.toFixed(2)}</span>
                            </div>
                        </div>
                    </form>
                </div>
            </Modal>
        </>
    )
}

export default DairyShopDEtails